import { render, staticRenderFns } from "./TutorCv.vue?vue&type=template&id=01909449&scoped=true"
import script from "./TutorCv.vue?vue&type=script&lang=js"
export * from "./TutorCv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01909449",
  null
  
)

export default component.exports